var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFavicontap4Loan(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.3095 3.08991C12.1983 3.21475 10.6071 5.23602 9.66424 6.44999C9.33341 6.87596 8.79209 7.57301 8.46136 7.99898L7.86001 8.77348L10.1326 8.78111C11.3825 8.78531 12.4095 8.78412 12.4148 8.77849C12.42 8.77283 12.4212 7.46515 12.4173 5.87248L12.4102 2.97675L12.3095 3.08991Z",
    fill: "#053171"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.23256 3.97519V4.97117L2.39267 4.98898C3.36399 5.09694 4.08288 5.71528 4.35198 6.6742C4.41238 6.88948 4.41505 6.95228 4.43307 8.57986L4.43316 8.58836C4.44849 9.97118 4.45222 10.3078 4.53018 10.6234C4.55527 10.725 4.58804 10.8244 4.63136 10.9558L4.63216 10.9582C5.00568 12.0912 5.84707 12.9656 6.94124 13.358C7.30373 13.4879 7.62454 13.5327 8.21938 13.5363L8.76237 13.5396L8.76961 12.1948L8.77685 10.8499L8.2127 10.836C7.56153 10.82 7.42238 10.7905 7.02795 10.5847C6.44007 10.278 6.03896 9.67857 5.93615 8.95293C5.87358 8.51152 5.96519 8.00801 6.1979 7.51412C6.33234 7.2288 6.48128 7.00533 6.86748 6.50956C7.00787 6.32934 7.53466 5.6457 8.03816 4.99035C8.54164 4.33501 9.08817 3.625 9.25268 3.41252C9.41719 3.20007 9.54581 3.01595 9.53855 3.00338C9.53128 2.99078 7.88446 2.9802 5.87895 2.97984L2.23256 2.97922V3.97519Z",
    fill: "#031950"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8532 10.5014C11.4278 10.6035 11.0914 10.79 10.7916 11.09C10.2565 11.6255 10.0069 12.3402 10.0347 13.2566L10.0433 13.5396L10.823 13.5383C11.6853 13.5369 11.856 13.5137 12.2504 13.3448C12.9577 13.0418 13.4797 12.4059 13.68 11.6034C13.7234 11.4296 13.7433 11.2421 13.7535 10.9108L13.7674 10.4565L12.8939 10.4589C12.2703 10.4606 11.9725 10.4727 11.8532 10.5014Z",
    fill: "#053171"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFavicontap4Loan);
export default __webpack_public_path__ + "static/media/favicontap4loan.2bc9c2e23200653e7944267fca7f2ee0.svg";
export { ForwardRef as ReactComponent };